import apiClient from './client'
import type {
  ActivityFilters,
  ActivityResponse,
} from '@/types/models'
import {
  adaptActivityResponse as adaptResponse,
  adaptActivityFilters,
} from '@/lib/utils/api-adapter'

/**
 * Activity API endpoints
 */
export const activityApi = {
  /**
   * List activity logs with optional filters
   */
  async list(filters?: ActivityFilters): Promise<ActivityResponse> {
    const response = await apiClient.get<any>('/api/v1/activity', {
      params: adaptActivityFilters(filters),
    })

    return {
      activities: (response.activities || []).map(adaptResponse),
      total: response.total || 0,
      limit: response.limit || 50,
      offset: response.offset || 0,
      hasMore: response.has_more || false,
    }
  },
}

export default activityApi
